export default {
      id: "icon--tooltip-usage",
      viewBox: "0 0 26 26",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--tooltip-usage",
      toString: function () {
        return this.url;
      }
    }